import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Btn, Input } from './careUi';

let open = null;

export const ask = (opts) => new Promise((resolve) => open && open({ ...opts, resolve }));

export function AskHost() {
  const [o, setO] = useState(null);
  const [shown, setShown] = useState(false);
  const [v, setV] = useState('');
  useEffect(() => { open = (x) => { setV(x.defaultValue || ''); setO(x); setShown(true); }; return () => { open = null; }; }, []);
  const close = (val) => { if (!shown) return; o?.resolve(val); setShown(false); };
  const needText = o && o.label;
  const ok = !needText || !o.required || v.trim().length >= (o.minLength || 1);
  return (
    <Dialog open={shown} onOpenChange={(x) => !x && close(null)}>
      <DialogContent className="max-w-md" data-testid="care-ask-dialog">
        <DialogHeader><DialogTitle>{o?.title}</DialogTitle></DialogHeader>
        {o?.message && <p className="text-sm text-slate-600">{o.message}</p>}
        {needText && <Input label={o.label} type={o.type || 'text'} value={v} onChange={(e) => setV(e.target.value)} textarea={o.textarea} testid="care-ask-input" autoFocus />}
        <div className="flex justify-end gap-2 mt-2">
          <Btn variant="ghost" onClick={() => close(null)} data-testid="care-ask-cancel">Cancel</Btn>
          <Btn variant={o?.danger ? 'danger' : 'primary'} disabled={!ok} onClick={() => close(needText ? v.trim() : true)} data-testid="care-ask-confirm">{o?.confirm || 'Confirm'}</Btn>
        </div>
      </DialogContent>
    </Dialog>
  );
}
